module.exports = __webpack_public_path__ + "img/fireice-vein.56294487.png";